import React from "react";
import { ProductsList } from "./ProductsList";
import { ProductGrid } from "./ProductCard";
// import { MdMargin } from "react-icons/md";
import { Link } from "react-router-dom";
import HeroProduct from "./Hero";

// Function to generate unique random indices
function getRandomIndices(count, len) {
  const idxArr = new Set(); // ✅ prevent duplicates
  while (idxArr.size < count) {
    idxArr.add(Math.floor(Math.random() * len));
  }
  return Array.from(idxArr);
}

export default function Home() {
  const categories = [
    "GiftCards",
    "FoodBeverages",
    "Wellness",
    "WeightLoss",
    "SkinCare",
    "HairCare",
    "Saas",
    "HomeSecurity",
    "HomeDecor",
    "Furniture",
    "FireSafety",
    "BathroomEssentials",
    "HomeAppliances",
  ];

  const count = 4; // now we want 4 categories
  const randomIndexes = getRandomIndices(count, categories.length);
  const selectedCategories = randomIndexes.map((i) => categories[i]);

  const [a, b, c, d] = selectedCategories;

  const productsA = ProductsList[a]?.products || [];
  const productsB = ProductsList[b]?.products || [];
  const productsC = ProductsList[c]?.products || [];
  const productsD = ProductsList[d]?.products || [];

  // console.log("Selected categories:", a, b, c, d);

  // Gradient colors for each heading
  const gradients = [
    "bg-gradient-to-r from-red-100 to-red-400",
    "bg-gradient-to-r from-green-100 to-green-400",
    "bg-gradient-to-r from-blue-100 to-blue-400",
    "bg-gradient-to-r from-purple-100 to-purple-400",
  ];

  return (
    <>
      <div>
        <HeroProduct />
      </div>
      <div className="space-y-12" style={{ marginTop: "100px" }}>
        {/* Category A */}
        <div className="bg-gray-100 ">
          <h2
            className={`text-2xl font-bold mb-4 text-center p-2 rounded  ${gradients[0]}`}
          >
            {a}
          </h2>
          <ProductGrid products={productsA} />
        </div>

        {/* Category B */}
        <div>
          <h2
            className={`text-2xl font-bold mb-4 text-center p-2 rounded ${gradients[1]}`}
          >
            {b}
          </h2>
          <ProductGrid products={productsB} />
        </div>

        {/* Category C */}
        <div>
          <h2
            className={`text-2xl font-bold mb-4 text-center p-2 rounded ${gradients[2]}`}
          >
            {c}
          </h2>
          <ProductGrid products={productsC} />
        </div>

        {/* Category D */}
        <div>
          <h2
            className={`text-2xl font-bold mb-4 text-center p-2 rounded ${gradients[3]}`}
          >
            {d}
          </h2>
          <ProductGrid products={productsD} />
        </div>
      </div>
    </>
  );
}
